import Skeleton from "../../ui/Skeleton";

function StudentsLoadingSkeleton() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:gap-5 md:grid-cols-2 xl:grid-cols-3">
      {[...Array(9)].map((_, i) => (
        <div
          key={i}
          className="rounded-xl border border-stroke bg-white p-4 shadow-sm dark:border-strokedark dark:bg-boxdark sm:rounded-2xl sm:p-6"
        >
          <div className="mb-4 flex items-start gap-3 sm:mb-5 sm:gap-4">
            <Skeleton className="h-14 w-14 flex-shrink-0 rounded-full sm:h-20 sm:w-20" />
            <div className="min-w-0 flex-1">
              <Skeleton className="mb-2 h-5 w-3/4 sm:h-6" />
              <Skeleton className="h-3 w-1/2 sm:h-4" />
            </div>
          </div>
          <div className="space-y-2 sm:space-y-3">
            <Skeleton className="h-8 w-full rounded-lg sm:h-10 sm:rounded-xl" />
            <Skeleton className="h-3 w-full sm:h-4" />
            <Skeleton className="h-3 w-2/3 sm:h-4" />
          </div>
          <div className="mt-4 flex gap-2 sm:mt-5 sm:gap-3">
            <Skeleton className="h-8 flex-1 rounded-lg sm:h-10 sm:rounded-xl" />
            <Skeleton className="h-8 w-8 rounded-lg sm:h-10 sm:w-10 sm:rounded-xl" />
            <Skeleton className="h-8 w-8 rounded-lg sm:h-10 sm:w-10 sm:rounded-xl" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default StudentsLoadingSkeleton;
